import { useSetState } from 'ahooks'
import { useEffect, useRef, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { Button, message, Spin, Steps } from 'antd'
import { SBack, SMessage } from 'shj-components'

import styles from './index.module.less'
import StepBaseInfo from './step1.tsx'
import StepPackageProduct from './step2/index.tsx'

import {
  getProjectList,
  getSubItemManagementInfo,
  getSubPackTreeTempTree,
  packModelTreeDetail,
  subItemManagementAdd,
  subItemManagementCleanCache,
  subItemManagementSave,
  upDateSubItemManagementInfo,
} from '@/services/product.ts'
import { httpOrgList } from '@/services/homeService.ts'

const AddOrEditSubItem = () => {
  const { id } = useParams()
  const [searchParams] = useSearchParams({})
  const step = searchParams.get('step')
  const editRef = useRef({ step1: {}, step2: {} })
  const [loading, setLoading] = useState(false)
  const [current, setCurrent] = useState(step ? Number(step) : 0)
  const [tempSubItemId, setTempSubItemId] = useState(null) // 暂存id
  const [options, setOptions] = useState<any>({ projectList: [], companyList: [] })
  const [spinning, setSpinning] = useState(false)
  const [state, setState] = useSetState<any>({
    treeNodes: [],
  }) //主体数据对象

  const stepList: any[] = [
    {
      subTitle: '基础信息',
      editRef: editRef.current.step1,
      components: (
        <StepBaseInfo
          editRef={editRef.current.step1}
          state={state}
          setState={(data: any) => setState({ ...state, ...data })}
        />
      ),
    },
    {
      subTitle: '子项打包',
      editRef: editRef.current.step2,
      components: (
        <StepPackageProduct
          options={options}
          // cacheId={tempSubItemId}
          fetchApi={packModelTreeDetail}
          editRef={editRef.current.step2}
          submitInfo={state}
          // setSubmitInfo={(data: any) => setState({ ...data })}
        />
      ),
    },
  ]

  useEffect(() => {
    getOptions()
    if (id) getInfo()
  }, [])

  const getInfo = () => {
    setSpinning(true)
    getSubPackTreeTempTree({
      subItemId: id,
    })
      .then((res: any) => {
        setState({ ...state, ...res })
        setTempSubItemId(res.id)
      })
      .finally(() => setSpinning(false))
  }

  const getOptions = async () => {
    const projectList = await getProjectList()
    const companyList = await httpOrgList()
    setOptions({ projectList, companyList })
  }

  const goBack = () => {
    SMessage.confirm({
      title: '确认继续返回',
      content: '返回将不会保存已添加信息',
      onOk: () => {
        history.back()
      },
    })
  }

  const onNext = () => {
    const ref = stepList[current].editRef
    setLoading(true)
    ref
      .onFinish()
      .then(res => {
        // ref.values = res
        // current === 0 && !tempSubItemId && setTempSubItemId(res.id)
        setCurrent(current + 1)
      })
      .finally(() => setLoading(false))
  }

  const onSubmit = () => {
    setSpinning(true)
    const ref = stepList[current].editRef
    ref
      .onFinish()
      .then(async res => {
        console.log(res, 'onSubmit---res')
        let api = state.id ? upDateSubItemManagementInfo : subItemManagementAdd
        api({ ...state, ...res })
          .then(res => {
            message.success(res.message || '操作成功')
            history.back()
          })
          .finally(() => setSpinning(false))
      })
      .catch(err => {
        setSpinning(false)
      })
  }

  return (
    <SBack
      title={`${id ? '编辑' : '新增'}子项`}
      level={2}
      goPath={goBack}
      extra={[
        <Button loading={loading} onClick={goBack}>
          取消
        </Button>,
        current > 0 && (
          <Button
            style={{ marginLeft: 10 }}
            loading={loading}
            onClick={() => setCurrent(current - 1)}
          >
            上一步
          </Button>
        ),
        current + 1 < stepList.length ? (
          <Button type="primary" loading={loading} style={{ marginLeft: 10 }} onClick={onNext}>
            下一步
          </Button>
        ) : (
          <Button type="primary" loading={loading} style={{ marginLeft: 10 }} onClick={onSubmit}>
            保存
          </Button>
        ),
      ]}
    >
      <div className={styles.container}>
        {/*<div className={styles.title_wrap}></div>*/}
        <Spin spinning={spinning}>
          <div className={styles.step_wrap}>
            <div className={styles.step_box}>
              <Steps current={current} items={stepList} />
            </div>
          </div>
          {/* <div className={styles.edit_wrap}>{stepList[current].components}</div> */}
          {stepList.map((item, i) => (
            <div
              className={styles.edit_wrap}
              key={i}
              style={{ display: current === i ? 'block' : 'none' }}
            >
              {item.components}
            </div>
          ))}
        </Spin>
      </div>
    </SBack>
  )
}

export default AddOrEditSubItem
